import { MULTIPLE_DRAWER_OFFSET_WIDTH } from "../constants";

interface IResolveOffsetWidthWhileSeveralDrawersOpenArguments {
  customWidth: string | number;
  drawersNumber: number;
}

export const resolveOffsetWidthMultipleDrawers = ({
  customWidth,
  drawersNumber,
}: IResolveOffsetWidthWhileSeveralDrawersOpenArguments): number => {
  let result = customWidth;
  const widthNumber = String(customWidth).match(/\d+/);

  if (widthNumber) {
    result =
      Number(widthNumber[0]) + drawersNumber * MULTIPLE_DRAWER_OFFSET_WIDTH;
  }

  return Number(result);
};
